module.exports = __webpack_public_path__ + "za.svg?9ed44aea09b417be8090dae8e5222232";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/1x1/za.svg
// module id = 1448
// module chunks = 0